import { Expose } from "class-transformer";

export class CreateProjectHasVehicleDto {
  @Expose()
  projectId: string;

  @Expose()
  vehicleId: string;
}
